import { addQuotes } from '../utils/smartutils';

export function cameraListByFilter(filter) {
  return `{cameraListByFilter(filter: ${JSON.stringify(filter).replace(
    /"([^(")"]+)":/g,
    '$1:'
  )} ) {
    id
    name
    startTime
    endTime
    url
    accesses {
      everyone
      schoolClass { id }
    }
}}`;
}

export function cameraMutationSave(values) {
  const accesses = values.relatedObjects.map((access) => ({
    id: access.id,
    quantity: access.quantity,
    type: access.type,
  }));
  return `mutation {
  cameraSave(
    camera: {
      id: ${values.id ? values.id : 0}
      name: ${addQuotes(values.name)}
      url: ${addQuotes(values.url)}
      startTime: ${addQuotes(values.startTime)}
      endTime: ${addQuotes(values.endTime)}
      relatedObjects: ${JSON.stringify(accesses).replace(
        /"([^(")"]+)":/g,
        '$1:'
      )}
    }
  ) {
    id
  }
}`;
}

export function cameraMutationRemove(id) {
  return `mutation {cameraRemove(id: ${id})}`;
}
